import React from 'react';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="App">
      {/* Background Animations */}
      <div className="gradient-mesh-bg"></div>

      <Header />
      <main>
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="border-t border-gray-800 pt-8">
            <p className="text-gray-300">&copy; 2024 Latant Consulting. All rights reserved.</p>
            <p className="text-gray-500 mt-2 text-sm">
              Transforming ideas into digital solutions
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
